import React from "react";
import JsonEditor from '../JsonEditor/JsonEditor';

import './JsonEditorField.css';

const JsonEditorField = ({ input }) => {
    return (
        <JsonEditor defaultValue={input?.value} onChange={ input?.onChange } />
    );
}

export default JsonEditorField;

